"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressMatchMeta$ = exports.AddressMatchMeta$outboundSchema = exports.AddressMatchMeta$inboundSchema = void 0;
exports.addressMatchMetaToJSON = addressMatchMetaToJSON;
exports.addressMatchMetaFromJSON = addressMatchMetaFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.AddressMatchMeta$inboundSchema = z.object({
    address_match_confidence: z.nullable(z.number()).optional(),
    elastic_search_score: z.nullable(z.number()).optional(),
    is_llm: z.boolean().default(false),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "address_match_confidence": "addressMatchConfidence",
        "elastic_search_score": "elasticSearchScore",
        "is_llm": "isLlm",
    });
});
/** @internal */
exports.AddressMatchMeta$outboundSchema = z.object({
    addressMatchConfidence: z.nullable(z.number()).optional(),
    elasticSearchScore: z.nullable(z.number()).optional(),
    isLlm: z.boolean().default(false),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        addressMatchConfidence: "address_match_confidence",
        elasticSearchScore: "elastic_search_score",
        isLlm: "is_llm",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AddressMatchMeta$;
(function (AddressMatchMeta$) {
    /** @deprecated use `AddressMatchMeta$inboundSchema` instead. */
    AddressMatchMeta$.inboundSchema = exports.AddressMatchMeta$inboundSchema;
    /** @deprecated use `AddressMatchMeta$outboundSchema` instead. */
    AddressMatchMeta$.outboundSchema = exports.AddressMatchMeta$outboundSchema;
})(AddressMatchMeta$ || (exports.AddressMatchMeta$ = AddressMatchMeta$ = {}));
function addressMatchMetaToJSON(addressMatchMeta) {
    return JSON.stringify(exports.AddressMatchMeta$outboundSchema.parse(addressMatchMeta));
}
function addressMatchMetaFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AddressMatchMeta$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AddressMatchMeta' from JSON`);
}
//# sourceMappingURL=addressmatchmeta.js.map